<template>
  <div class="QRCodeShow">
    <div :id="`qrcode${randomTime}`" ref="qrcode" style="display: inline-block;" />
    <div class="down-title">
      {{ qrCodeIp }}
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  name: 'QRCodeShow',
  props: {
    qrCodeIp: {
      type: String,
      default() {
        return '';
      }
    },
    randomTime: {
      type: Number,
      default: 1
    }
  },
  watch: {
    randomTime: {
      handler: function(val, oldVal) {
        this.$nextTick(function() {
          this.qrcode();
        });
      },
      immediate: true
    }
  },
  methods: {
    // init二维码生成
    qrcode(id) {
      const url = this.qrCodeIp;
      document.getElementById('qrcode' + this.randomTime).innerHTML = '';
      new QRCode('qrcode' + this.randomTime, {
        width: 135, // 设置宽度，单位像素
        height: 135, // 设置高度，单位像素
        text: url // 设置二维码内容或跳转地址
      });
      // 重写二维码的title
      document.getElementById('qrcode' + this.randomTime).title = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.QRCodeShow{
  text-align: center;
  .down-title{
    text-align: center;
    margin-top:10px;
  }
}
</style>
